import { getKnowledges } from "../knowledges";
import BaseGroupItem from "./BaseGroupItem";
import { Group, Title } from "@mantine/core";
import { useSupportLanguage } from "../stores/SupportLanguageStore";

const BaseList = () => {
  const lang = useSupportLanguage((s) => s.language);
  return (
    <>
      <Title order={2} fw={500} ta={"center"}>
        {lang.explore}
      </Title>
      <Group justify="center" mt={"xl"} gap={"xl"} align="stretch">
        {getKnowledges(lang).map((item, index) => (
          <BaseGroupItem key={index} {...item} />
        ))}
      </Group>

      {/* <PopularArticles /> */}
    </>
  );
};

export default BaseList;
